module.exports = __webpack_public_path__ + "static/Mobile-0576c4d78291fd7825dcb367db1b7dbb.png";